/*
 * @Author: Zhouqi
 * @Date: 2025-11-15 17:40:57
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-08 18:23:48
 */
import { forwardRef, useImperativeHandle, useRef } from 'react';

import TaskPanel, { TaskPanelRef } from './taskPanel';

// Re-export events for external use
export { dispatchExpandPanel, dispatchTaskSubmitted, TASK_PANEL_EVENTS } from './events';

export interface DrawerTaskPanelProps {
  collapse?: boolean;
  /**
   * 距离视口顶部的距离（与 Right 组件对齐）
   */
  top?: number;
  /**
   * 距离视口底部的距离（与 Right 组件对齐）
   */
  bottom?: number;
  /**
   * 高度（与 Right 组件对齐）
   */
  height?: number;
  /**
   * 空状态文本
   */
  emptyText?: React.ReactNode;
}
export interface DrawerTaskPanelRef {
  refresh: () => void;
}

const DrawerTaskPanel = forwardRef<DrawerTaskPanelRef, DrawerTaskPanelProps>(
  (props, ref) => {
    const collapse = props.collapse ?? false;

    const taskPanelRef = useRef<TaskPanelRef>(null);

    useImperativeHandle(ref, () => ({
      refresh: () => {
        taskPanelRef.current?.refresh();
      },
    }));

    return (
      <div
        className="bg-[#ffffff] rounded-[8px] overflow-hidden z-[998] h-full"
        style={{
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          width: collapse ? '382px' : '0',
          opacity: collapse ? 1 : 0,
          // padding: collapse ? '16px' : 0,
          // 动态设置位置和高度，与 Right 组件保持一致
          // ...(height ? { height: `${height}px` } : {}),
          visibility: collapse ? 'visible' : 'hidden',
          pointerEvents: collapse ? 'auto' : 'none',
        }}
      >
        <div
          style={{
            opacity: collapse ? 1 : 0,
            transition: 'opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0.1s',
          }}
        >
          {collapse && <TaskPanel ref={taskPanelRef} emptyText={props.emptyText} />}
        </div>
      </div>
    );
  },
);
export default DrawerTaskPanel;
